// extracted by mini-css-extract-plugin
module.exports = {"container":"sectionTitle_container__3NhZ7","title":"sectionTitle_title__3hfz0"};